<!--数据核对功能说明页面-->
<template>
  <div class="import-checking-page">
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row class="main-content">
      <el-col :span="4" class="menu-col">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20" class="content-col">
        <!-- 页面标题 -->
        <div class="page-header">
          <div class="header-icon">✅</div>
          <div class="header-text">
            <h2>导入数据核对</h2>
            <p>导入包含数据的Excel文件，让填表人核对并修订数据</p>
          </div>
        </div>

        <!-- 内容卡片 -->
        <div class="content-card">
          <!-- 场景说明 -->
          <div class="info-section">
            <div class="section-title">
              <i class="el-icon-question"></i>
              <span>什么场景下需要核对？</span>
            </div>
            <div class="section-content">
              <p>主要是已经存在部分数据，需要填表人<strong>补充部分数据</strong>或者<strong>修订部分数据</strong>的场景。</p>
              <div class="example-box">
                <div class="example-title">常见应用场景：</div>
                <ul class="example-list">
                  <li><i class="el-icon-check"></i> 每学期开学更新学生联系方式</li>
                  <li><i class="el-icon-check"></i> 定期更新员工家庭住址</li>
                  <li><i class="el-icon-check"></i> 核对并修正历史数据错误</li>
                  <li><i class="el-icon-check"></i> 补充完善已有表格信息</li>
                </ul>
              </div>
            </div>
          </div>

          <!-- 分隔线 -->
          <div class="divider"></div>

          <!-- 小程序入口 -->
          <div class="miniapp-section">
            <div class="section-title">
              <i class="el-icon-mobile-phone"></i>
              <span>使用"核对信息"小程序</span>
            </div>
            <div class="section-content center">
              <p class="miniapp-desc">核对信息请使用我们的"核对信息小程序"，微信扫码即可打开：</p>
              <div class="qrcode-box">
                <img src="/form/images/checking_qrcode.jpg" class="qrcode-img" />
                <div class="qrcode-tip">
                  <i class="el-icon-full-screen"></i>
                  <span>微信扫码打开小程序</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 操作提示 -->
        <div class="action-tips">
          <div class="tip-card" @click="showMustRead">
            <i class="el-icon-reading"></i>
            <span>导入必读</span>
          </div>
          <div class="tip-card" @click="showCheckForm">
            <i class="el-icon-warning-outline"></i>
            <span>表格要求</span>
          </div>
          <div class="tip-card" @click="howToSwitch">
            <i class="el-icon-question"></i>
            <span>浏览器设置</span>
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- 浏览器模式切换弹窗 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="browserSwitchDialogVisible" custom-class="custom-dialog" width="700px">
      <div slot="title" class="dialog-title">
        <i class="el-icon-question"></i>
        <span>如何切换浏览器的模式</span>
      </div>
      <div class="dialog-body">
        <div class="instruction-step">
          <span class="step-num">1</span>
          <span>找到浏览器地址栏右侧的图标（如下图所示红色框部分）</span>
        </div>
        <div class="instruction-image">
          <img src="../assets/switch_browser.png" />
        </div>
        <div class="instruction-step">
          <span class="step-num">2</span>
          <span>点击切换到闪电图标或"极速模式"/"高速模式"</span>
        </div>
        <div class="instruction-image">
          <img src="../assets/good_browser.png" />
        </div>
        <div class="instruction-tip">
          <i class="el-icon-info"></i>
          <span>切换完成后请刷新页面重新登录</span>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn-primary-custom" @click="browserSwitchDialogVisible=false">我知道了</el-button>
      </div>
    </el-dialog>

    <!-- 检查表格弹窗 -->
    <el-dialog :close-on-click-modal="false" v-dialogDrag :visible.sync="checkFormDialogVisible" custom-class="custom-dialog" width="600px">
      <div slot="title" class="dialog-title warning">
        <i class="el-icon-warning"></i>
        <span>表格不能有合并的单元格</span>
      </div>
      <div class="dialog-body">
        <div class="notice-box">
          <p>为了方便核查数据，以及减少导入过程中出错的可能性，<strong>请将表格中合并单元格全部取消后再导入</strong>。</p>
          <div class="section-divider"></div>
          <div class="solution">
            <h4>取消合并单元格的方法：</h4>
            <ol>
              <li>选中包含合并单元格的区域</li>
              <li>点击"合并单元格"按钮取消合并</li>
              <li>取消后如有空白单元格，请填充好数据，方便后期确认</li>
            </ol>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="checkFormDialogVisible=false">知道了</el-button>
      </div>
    </el-dialog>

    <!-- 导入必读弹窗 -->
    <el-dialog :close-on-click-modal="false" v-dialogDrag :visible.sync="mustReadDialogVisible" custom-class="custom-dialog" width="700px">
      <div slot="title" class="dialog-title">
        <i class="el-icon-reading"></i>
        <span>表格导入必读</span>
      </div>
      <div class="dialog-body">
        <div class="qa-list">
          <div class="qa-item">
            <div class="qa-question">
              <span class="qa-badge q">Q</span>
              <span>适合导入什么样的表格？</span>
            </div>
            <div class="qa-answer">
              <span class="qa-badge a">A</span>
              <span>适合导入<strong>首行是表头，每行是填表人需要填写数据</strong>的表格；如果是复杂表格，请自行设计成首行是表头的表格后再导入。</span>
            </div>
          </div>

          <div class="qa-item">
            <div class="qa-question">
              <span class="qa-badge q">Q</span>
              <span>在什么情况下使用导入表格功能？</span>
            </div>
            <div class="qa-answer">
              <span class="qa-badge a">A</span>
              <span>一种情况是您有表格，手机端制作录入麻烦，可以用导入；另一种情况是需要填表人修改您excel表格里的数据，比如修订已有数据。</span>
            </div>
          </div>

          <div class="qa-item">
            <div class="qa-question">
              <span class="qa-badge q">Q</span>
              <span>在什么情况导入空表？</span>
            </div>
            <div class="qa-answer">
              <span class="qa-badge a">A</span>
              <span>需要填表人填表时导入空表。</span>
            </div>
          </div>

          <div class="qa-item">
            <div class="qa-question">
              <span class="qa-badge q">Q</span>
              <span>在什么情况导入数据？</span>
            </div>
            <div class="qa-answer">
              <span class="qa-badge a">A</span>
              <span>需要填表人修改您excel表格上的数据时导入数据。</span>
            </div>
          </div>

          <div class="qa-item">
            <div class="qa-question">
              <span class="qa-badge q">Q</span>
              <span>表头特别复杂怎么导入？</span>
            </div>
            <div class="qa-answer">
              <span class="qa-badge a">A</span>
              <span>导入表格要观察列，因为一个列是一个数据，所以这个列叫什么就给这个列取什么名字。列名可以在预览界面点击单元格选择，可以减少输入量。</span>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn-primary-custom" @click="mustReadDialogVisible=false">我知道了</el-button>
      </div>
    </el-dialog>

    <!-- 万能快查弹窗 -->
    <el-dialog :close-on-click-modal="false" v-dialogDrag :visible.sync="wanSearchDialogVisible" custom-class="custom-dialog" width="400px">
      <div slot="title" class="dialog-title">
        <i class="el-icon-magic-stick"></i>
        <span>万能快查，发啥查啥</span>
      </div>
      <div class="dialog-body center">
        <div class="qrcode-box">
          <img :src="qr_wansearch_url" class="qrcode-img" />
          <p class="qrcode-tip">微信扫码打开万能快查小程序</p>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="wanSearchDialogVisible=false">知道了</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'

  export default {
    components: {
      MenuList,
      Header
    },
    data() {
      return {
        username: '',
        browserSwitchDialogVisible: false,
        fileList: [],
        courses: [],
        file: '',
        editForm: {
          id: '',
          exam: '',
          course: '',
          grade: '',
          paper_score: ''
        },

        checkFormDialogVisible: false,
        mustReadDialogVisible: false,

        wanSearchDialogVisible: false,

        qr_wansearch_url: '/form/images/wansearch_qrcode.jpg'
      }
    },
    created() {
      this.username = this.$session.get('USERNAME')
    },
    methods: {
      handleRemove(file, fileList) {
        this.fileList = []
      },
      handlePreview(file) {},
      uploadFile(file) {},
      handleExceed(files, fileList) {
        this.$message.warning(`请先删除原来上传的文件后再上传!`)
        return true
      },
      beforeRemove(file, fileList) {
        return this.$confirm(`确定移除 ${file.name}？`)
      },
      uploadExcelFile() {
        if (this.fileList.length === 0) {
          this.$message.error('请上传excel文件！')
          return
        }

        let that = this

        let data = new FormData()
        data.set('username', this.username)

        let tmpExcelFile = this.fileList[0].raw

        data.append('file', tmpExcelFile)

        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/form/web/_upload_data_excel_for_preview.jsp'
        this.axios.post(requestUrl, data, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(res => {
          console.log('数据导入完成！！')

          if (res.data.result === '1') {
            var uploaded_excel_file_name = res.data.excel_file
            that.$router.push({
                name: 'excel_data_preview',
                params: {
                  username: that.username,
                  excel_file: uploaded_excel_file_name
                }
              })
          }
          load.close()
        }).catch(err => {
          console.log('数据导入异常！！')
          console.log(err)
          load.close()
          that.$router.push('/import_data_excel')
        })
      },

      fileChange(file, fileList) {
        this.fileList = fileList
        console.log(fileList)
        return true
      },
      back() {
        this.$router.push('/validation_form_list')
      },
      emptyFileList() {
        this.fileList = []
      },
      howToSwitch() {
        this.browserSwitchDialogVisible = true
      },
      showMustRead() {
        this.mustReadDialogVisible = true
      },
      showCheckForm() {
        this.checkFormDialogVisible = true
      },
      openWanSearch() {
        this.wanSearchDialogVisible = true
      }

    }
  }
</script>

<style scoped>
  /* 页面整体布局 */
  .import-checking-page {
    min-height: 100vh;
    background: #f5f7fa;
  }

  .main-content {
    padding: 20px;
  }

  .menu-col {
    padding-right: 20px;
  }

  .content-col {
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 4px 20px rgba(0,0,0,0.06);
    padding: 30px;
    min-height: calc(100vh - 140px);
  }

  /* 页面标题 */
  .page-header {
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    padding-bottom: 20px;
    border-bottom: 2px solid #f0f0f0;
  }

  .header-icon {
    font-size: 48px;
    margin-right: 20px;
  }

  .header-text h2 {
    font-size: 24px;
    color: #1a1a1a;
    margin: 0 0 6px;
    font-weight: 600;
  }

  .header-text p {
    font-size: 14px;
    color: #888;
    margin: 0;
  }

  /* 内容卡片 */
  .content-card {
    max-width: 800px;
    margin: 0 auto 30px;
  }

  /* 信息区块 */
  .info-section {
    margin-bottom: 30px;
  }

  .section-title {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 18px;
    font-weight: 600;
    color: #1a1a1a;
    margin-bottom: 20px;
  }

  .section-title i {
    font-size: 22px;
    color: #1485FB;
  }

  .section-content {
    font-size: 15px;
    color: #555;
    line-height: 1.8;
  }

  .section-content.center {
    text-align: center;
  }

  .section-content p {
    margin: 0 0 20px;
  }

  /* 示例框 */
  .example-box {
    background: #f8f9fa;
    border-radius: 12px;
    padding: 20px;
    margin-top: 20px;
  }

  .example-title {
    font-weight: 600;
    color: #1a1a1a;
    margin-bottom: 15px;
    font-size: 15px;
  }

  .example-list {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .example-list li {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 12px;
    font-size: 14px;
    color: #555;
  }

  .example-list li:last-child {
    margin-bottom: 0;
  }

  .example-list i {
    color: #2CCB92;
    font-size: 16px;
    font-weight: bold;
  }

  /* 分隔线 */
  .divider {
    height: 1px;
    background: linear-gradient(90deg, transparent 0%, #e0e0e0 50%, transparent 100%);
    margin: 30px 0;
  }

  /* 小程序区域 */
  .miniapp-section {
    padding-top: 10px;
  }

  .miniapp-desc {
    font-size: 15px;
    color: #666;
    margin-bottom: 25px;
  }

  .qrcode-box {
    display: inline-block;
    background: #fff;
    border-radius: 16px;
    padding: 20px;
    box-shadow: 0 4px 20px rgba(0,0,0,0.08);
    border: 1px solid #f0f0f0;
  }

  .qrcode-img {
    width: 200px;
    height: 200px;
    border-radius: 12px;
    display: block;
  }

  .qrcode-tip {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-top: 15px;
    font-size: 14px;
    color: #666;
  }

  .qrcode-tip i {
    color: #2CCB92;
    font-size: 16px;
  }

  /* 操作提示卡片 */
  .action-tips {
    display: flex;
    justify-content: center;
    gap: 20px;
    flex-wrap: wrap;
  }

  .tip-card {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 16px 24px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0,0,0,0.06);
    cursor: pointer;
    transition: all 0.3s ease;
    font-size: 14px;
    color: #555;
    border: 1px solid #f0f0f0;
  }

  .tip-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 6px 20px rgba(0,0,0,0.1);
    border-color: #1485FB;
    color: #1485FB;
  }

  .tip-card i {
    font-size: 20px;
    color: #1485FB;
  }

  /* ==================== 弹窗样式 ==================== */
  ::v-deep .custom-dialog .el-dialog__header {
    background: linear-gradient(135deg, #1485FB 0%, #0d6efd 100%);
    padding: 0;
  }

  .dialog-title {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 20px;
    color: #fff;
    font-size: 18px;
    font-weight: 600;
  }

  .dialog-title i {
    font-size: 20px;
  }

  .dialog-title.warning {
    background: linear-gradient(135deg, #ff6b6b 0%, #ff4d4f 100%);
  }

  ::v-deep .custom-dialog .el-dialog__headerbtn {
    top: 20px;
    right: 20px;
  }

  ::v-deep .custom-dialog .el-dialog__headerbtn .el-dialog__close {
    color: rgba(255,255,255,0.8);
  }

  ::v-deep .custom-dialog .el-dialog__headerbtn:hover .el-dialog__close {
    color: #fff;
  }

  ::v-deep .custom-dialog .el-dialog__body {
    padding: 30px;
  }

  ::v-deep .custom-dialog .el-dialog__footer {
    border-top: 1px solid #f0f0f0;
    padding: 20px 30px;
  }

  .dialog-body {
    max-height: 500px;
    overflow-y: auto;
  }

  .dialog-body.center {
    text-align: center;
  }

  /* 步骤说明 */
  .instruction-step {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 15px;
    font-size: 14px;
    color: #555;
  }

  .step-num {
    width: 28px;
    height: 28px;
    background: linear-gradient(135deg, #1485FB 0%, #0d6efd 100%);
    color: #fff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 600;
    flex-shrink: 0;
  }

  .instruction-image {
    margin: 15px 0 25px;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 12px rgba(0,0,0,0.1);
  }

  .instruction-image img {
    width: 100%;
    display: block;
  }

  .instruction-tip {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 16px;
    background: #e6f7ff;
    border-radius: 8px;
    font-size: 13px;
    color: #1485FB;
  }

  /* 提示框 */
  .notice-box {
    font-size: 14px;
    line-height: 1.8;
    color: #555;
  }

  .notice-box p {
    margin: 0 0 15px;
  }

  .section-divider {
    height: 1px;
    background: #f0f0f0;
    margin: 20px 0;
  }

  .solution h4 {
    font-size: 15px;
    color: #1a1a1a;
    margin: 0 0 12px;
  }

  .solution ol {
    margin: 0;
    padding-left: 20px;
    color: #666;
  }

  .solution li {
    margin-bottom: 8px;
  }

  /* Q&A 列表 */
  .qa-list {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .qa-item {
    padding: 20px;
    background: #f8f9fa;
    border-radius: 12px;
    border-left: 3px solid #1485FB;
  }

  .qa-question {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 15px;
    font-weight: 600;
    color: #1a1a1a;
    margin-bottom: 12px;
  }

  .qa-answer {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    font-size: 14px;
    color: #555;
    line-height: 1.6;
  }

  .qa-badge {
    width: 24px;
    height: 24px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 700;
    flex-shrink: 0;
  }

  .qa-badge.q {
    background: linear-gradient(135deg, #1485FB 0%, #0d6efd 100%);
    color: #fff;
  }

  .qa-badge.a {
    background: linear-gradient(135deg, #2CCB92 0%, #25b582 100%);
    color: #fff;
  }

  /* 按钮样式 */
  .btn-primary-custom {
    padding: 10px 24px;
    font-size: 14px;
    border-radius: 8px;
    background: linear-gradient(135deg, #1485FB 0%, #0d6efd 100%);
    border: none;
    color: #fff;
    font-weight: 500;
    transition: all 0.3s ease;
  }

  .btn-primary-custom:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(20, 133, 251, 0.35);
    background: linear-gradient(135deg, #2d91fb 0%, #1a7cff 100%);
  }

  /* 响应式 */
  @media (max-width: 1200px) {
    .main-content {
      padding: 15px;
    }

    .content-col {
      padding: 20px;
    }

    .action-tips {
      gap: 10px;
    }

    .tip-card {
      padding: 12px 18px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/import_checking.vue